import React from "react";
import { MapPin } from "lucide-react";

export class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err) {
    console.error("Map failed to load:", err);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full h-full flex flex-col items-center justify-center bg-[#E8E6DF] text-center p-8" data-testid="map-error">
          <MapPin className="h-10 w-10 text-[#5C6660] mb-3" />
          <p className="font-heading text-lg text-[#1C211F]">Map unavailable</p>
          <p className="text-sm text-[#5C6660] mt-1 max-w-xs">
            We couldn't load the map right now. The facility list on the left is still fully available.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
